export const STATIC_CONF = {
  activePlants: {
    getactiveplants: 'v1/getactiveplants',
  },
  dataGrid: {
    allowedPageSizes: [10, 25, 50, 100, 200, 1000],
    defaultPageSize: 10,
  },
  devExtremeLicenseKey:
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjFmOWJiNzBiLTMzNWYtNGE4ZS1iNzY4LWQ4M2ZiMzA4NWVlOCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.nYa0r+vx4XZWeivST4J3m9NRzvw01PJ9z3N3nWUheVD9pXoCJX6wbr6UHuCTHXNG7BdUxScPSf25tW+xd3LtCudJfROgnePJdsBgGmj8ISkW+GFhFnO9wZAHGCzaq18vzVF2Kg==',
  feedback: {
    saveFeedback: 'api/v1/UserFeedback/SaveFeedback',
  },
  language: {
    default: {
      code: 'en',
      description: 'English',
      language: 'en-EN',
    },
    languages: [
      {
        code: 'cz',
        description: 'Čeština',
        language: 'cs-CZ',
      },
      {
        code: 'en',
        description: 'English',
        language: 'en-EN',
      },
    ],
  },
  loggingEndpoint: 'https://dev.orion.cz.foxconn.com/api/FrontEndLogger/LogError',
  login: {
    apiLoginUrl: '',
    apiLogoutUrl: '',
  },
  modulesBaseUrl: {
    configurator: {
      copyWorkflow: 'api/v1/WorkFlow/Library/CopyWorkFlow',
      deleteWorkflow: 'api/v1/WorkFlow/Library/DeleteWorkFlow',
      exportWorkflow: 'api/v1/WorkFlow/Library/ExportWorkFlow',
      getElementParameters: 'api/v1/WorkFlow/Catalogue/GetElementParameters',
      getElements: 'api/v1/WorkFlow/Catalogue/GetElements',
      getHistory: 'api/v1/WorkFlow/Library/GetHistory',
      getPlants: 'api/v1/adapter/workflow/getPlants',
      getWorkflow: 'api/v1/WorkFlow/Library/GetWorkFlow',
      getWorkFlowLocks: 'api/v1/WorkFlow/Library/GetWorkFlowLocks',
      getWorkFlowRevisions: 'api/v1/WorkFlow/Library/GetWorkFlowRevisions',
      getWorkflows: 'api/v1/WorkFlow/Library/GetWorkFlows',
      importWorkFlow: 'api/v1/WorkFlow/Library/ImportWorkFlow',
      lockWorkflow: 'api/v1/WorkFlow/Library/LockWorkflow',
      releaseWorkFlow: 'api/v1/WorkFlow/Library/ReleaseWorkFlow',
      releaseWorkflow: 'api/v1/WorkFlow/Library/ReleaseWorkFlow',
      saveProcess: 'api/v1/WorkFlow/Library/SaveProcess',
      saveWorkflow: 'api/v1/WorkFlow/Library/SaveWorkFlow',
      unlockWorkflow: 'api/v1/WorkFlow/Library/unlockWorkflow',
      workflow: 'api/v1/WorkFlow/Library/GetWorkFlow',
      workflows: 'api/v1/WorkFlow/Library/GetWorkFlows',
    },
    materialManagement: {
      addCalculationLineDetail:
        'api/v2/MaterialManagement/MMViewConfiguration/AddCalculationLineDetail',

      approvedVendorList: 'api/v1/MaterialManagement/ApprovedVendorList',
      auditLog: 'api/v1/auditlogs',
      autoComplete:
        'api/v2/MaterialManagement/MMViewConfiguration/GetAllCalculationsforAutoComplete/',
      bufferRules: 'api/v1/MaterialManagement/BufferRules',
      carriers: 'api/v1/logistics/carriers',
      chartData: 'api/v1/ExternalDataStore/GetCsvJson?Path=SupplyVS/Charts/',
      commits: 'api/v1/MaterialManagement/Commits',
      commitsFilterAdditions: 'api/v1/materialmanagement/commits/getcommitsbyfilteradditions',
      commitsReadOnlyFields: 'api/v1/materialmanagement/commits/getreadonlyfields',
      contacts: 'api/v1/Contacts/GetContacts',
      countries: 'api/v1/countries',
      createCalculationLine: 'api/v2/MaterialManagement/MMViewConfiguration/CreateCalculationLine',
      createCalculationLineConditionalFormat:
        'api/v2/materialmanagement/mmviewconfiguration/createcalculationlineconditionalformating',
      createCalculationLineDetail:
        'api/v2/MaterialManagement/MMViewConfiguration/CreateCalculationLineDetail',
      createIdentity: 'api/v1/identityhub/newidentity',
      createSVComment: 'api/v1/NotesAndComments/Comment/InsertComment',
      createSVNote: 'api/v1/NotesAndComments/Note/InsertNote',
      createSVPredefinedComment:
        'api/v1/NotesAndComments/PredefinedComment/InsertPredefinedComment',
      createView: 'api/v2/MaterialManagement/MMViewConfiguration/CreateMaterialManagementView',
      dashboards: 'Dashboards',
      deleteCalculationLineById:
        'api/v2/MaterialManagement/MMViewConfiguration/deleteCalculationLineID',
      deleteCalculationLineConditionalFormat:
        'api/v2/materialmanagement/mmviewconfiguration/deletecalculationlineconditionalformating',
      deleteCalculationLineDetail:
        'api/v2/MaterialManagement/MMViewConfiguration/DeleteCalculationLineDetail',
      deleteNoteAndComment: 'api/v1/NotesAndComments/NoteComment/DeleteNoteAndComment',
      deleteSVComment: 'api/v1/NotesAndComments/Comment/DeleteComment',
      deleteSVNote: 'api/v1/NotesAndComments/Note/DeleteNote',
      deleteSVPredefinedComment:
        'api/v1/NotesAndComments/PredefinedComment/DeletePredefinedComment',
      deleteView: 'api/v2/MaterialManagement/MMViewConfiguration/DeleteMaterialManagementView',
      downloadCalculationLineDetail:
        'api/v2/MaterialManagement/MMViewConfiguration/getuploadcalculationlinedetail',
      downloadCalendar: 'api/v1/logistics/slots/getuploadcalendar',
      downloadIdentities: 'api/v1/identityhub/getuploadidentities',
      downloadVendorList: 'api/v1/MaterialManagement/PartNumbers/GetUploadContacts',
      downloadXlsxShipments: '/getuploadshipments',
      dummyCommits: 'api/v1/MaterialManagement/DummyCommits',
      forecastDate:
        'api/v1/MaterialManagement/PlannedOrders/GetPlannedOrderPlanningDate?SyncSAP=false',
      getAdditionInfoByPartNumber:
        'api/v1/MaterialManagement/PartNumbers/GetPartNumberAdditionInfos',
      getApplication: 'api/v1/QapDataExchange/ApplicationConfig',
      getApplications: 'api/v1/QapDataExchange/Applications',
      getBuyersPartNumbersList: 'api/v1/MaterialManagement/ApprovedVendorList/GetBuyerPNs',
      getCalculationLineByID:
        'api/v2/MaterialManagement/MMViewConfiguration/getCalculationLineByID',
      getDefaultCarrierFormSettingFields: 'api/v1/Logistics/Carriers/GetDefaultFormSettingFields',
      getDefaultContactsFormSettingFields: 'api/v1/identityhub/getdefaultformsettingfields',
      getDefaultFormSettingFields: 'api/v1/materialmanagement/commits/getdefaultformsettingfields',
      getDefaultStockFormSettingFields: 'api/v1/Logistics/Carriers/GetDefaultFormSettingFields',
      getDefaultVendorFormSettingFields:
        'api/v1/MaterialManagement/Vendors/GetDefaultFormSettingFields',
      getHeaderForPrecalculate: 'api/v1/MaterialManagement/DummyCommits/GetHeaderForPrecalculate',
      getIdentityByKey: 'api/v1/identityhub/getidentitybykey',
      GetMandatoryFields: 'api/v1/materialmanagement/commits/GetMandatoryFields',
      getNotesAndComments: 'api/v1/NotesAndComments/NoteComment/GetNotesAndComments',
      getNotesByRecord: 'api/v1/NotesAndComments/Note/GetNotesByRecord',
      getNotesByUser: 'api/v1/NotesAndComments/Note/GetNotesByUser',
      getPartNumbersByContacts: 'api/v1/MaterialManagement/PartNumbers/GetPartNumbersByContacts',
      getPNsPrecalculateProjectionByFilter:
        'api/v2/MaterialManagement/SupplyVisibilityReadOnly/GetPNsPrecalculateProjectionByFilter',
      getPrecalculateProjection:
        'api/v2/MaterialManagement/SupplyVisibility/GetPrecalculateProjection',
      getPrecalculateProjections:
        'api/v2/MaterialManagement/SupplyVisibility/GetPrecalculateProjections',
      getProjectionsByPrecalculations:
        'api/v2/MaterialManagement/SupplyVisibility/GetProjectionsByPrecalculation',
      getShipmentsByFilter: '/GetShipmentsByFilter',
      getSVCommentsByVendorPN: 'api/v1/NotesAndComments/Comment/GetCommentsByRecord',
      getSVPredefinedComment: 'api/v1/NotesAndComments/PredefinedComment/GetPredefinedComments',
      getUploadNotesAndComments: 'api/v1/NotesAndComments/NoteComment/GetUploadNotesAndComments',
      getUserApplications: 'api/v1/QapDataExchange/UserApplications',
      getVendorCodeNames: 'api/v1/MaterialManagement/PartNumbers/GetVendorCodeNames',
      getVendorCodes: 'api/v1/MaterialManagement/PartNumbers/GetVendorCodes',
      getVendorsByContacts: 'api/v1/MaterialManagement/Vendors/GetVendorsByContacts',
      getVendorsWithNames: 'api/v1/materialmanagement/Vendors/GetVendorsWithNames',
      globalNotifications: 'GlobalNotifications',
      identitiesRequestStatus: 'api/v1/identityhub/-/requeststatus',
      identityHub: 'api/v1/identityhub',
      identityList: 'api/v1/identityhub/getidentitylist',
      mmViews: 'api/v2/MaterialManagement/MMViewConfiguration/GetMaterialManagementViews',
      multiValues:
        'api/v2/MaterialManagement/MMViewConfiguration/GetListCalculationLineOrderViewByMMViewID',
      multiValuesUpdate:
        'api/v2/MaterialManagement/MMViewConfiguration/SaveListMaterialManagementViewCalculationLine',
      Notification: 'api/v1/Contacts',
      notifications: 'Notifications',
      partNumbers: 'api/v1/materialmanagement/partnumbers',
      partNumbersContacts: 'api/v1/identityhub/getidentitybykey',
      pnSectionName: 'api/v1/MaterialManagement/PartNumbers/GetPartNumberSectionNames',
      pnSectionNameByContact:
        '/api/v1/MaterialManagement/PartNumbers/GetPartNumberSectionNamesByContact',
      postUploadIdentities: 'api/v1/identityhub/postuploadidentities',
      postUploadNotesAndComments: 'api/v1/NotesAndComments/NoteComment/PostUploadNotesAndComments',
      purchaseOrders: 'api/v1/MaterialManagement/PurchaseOrders',
      qlikGetDataFromApp: 'api/v1/QlikDataExchange/GetDataFromApp',
      quotations: 'api/v1/quotations',
      quotationVendor: 'api/v1/quotations/quotationvendor',
      setPartNumberVendorCodeSectionName:
        'api/v1/MaterialManagement/PartNumbers/CreatePartNumberVendorCodeSectionName',
      sharedWidgets: 'SharedWidgets',
      shipments: 'api/v1/logistics/shipments',
      shipmentsOrch: 'api/v1/logistics/shipmentsOrch',
      singleValues:
        'api/v2/MaterialManagement/MMViewConfiguration/GetFixListCalculationLineOrderViewByMMViewID',
      singleValuesUpdate:
        'api/v2/MaterialManagement/MMViewConfiguration/SaveListMaterialManagementFix',
      slots: 'api/v1/logistics/slots',
      slotsModule: {
        downloadXlsxSlots: 'api/v1/logistics/slots/getuploadslots',
        getSlotsByFilter: 'api/v1/logistics/slots/getslotsbyfilter',
      },
      slotStorages: 'api/v1/Logistics/SlotStorages',
      stocks: 'api/v1/logistics/stocks',
      supplyVisibility: 'api/v2/MaterialManagement/SupplyVisibility',
      syncPlo: 'api/v1/materialmanagement/plannedorders/synchronizeplannedorders',
      templateSettings: 'TemplateSettings',
      transportType: 'api/v1/logistics/typeoftransports',
      updateCalculationLine: 'api/v2/MaterialManagement/MMViewConfiguration/UpdateCalculationLine',
      updateCalculationLineConditionalFormat:
        'api/v2/MaterialManagement/MMviewConfiguration/UpdateCalculationLineConditionalFormating',
      updateCalculationLineDetail:
        'api/v2/MaterialManagement/MMViewConfiguration/UpdateCalculationLineDetail',
      updateIdentity: 'api/v1/identityhub/updateidentity',
      updateNoteAndComment: 'api/v1/NotesAndComments/NoteComment/UpdateNoteAndComment',
      updatePartNumberAdditionInfo:
        'api/v1/MaterialManagement/PartNumbers/UpdatePartNumberAdditionInfo',
      updateSVComment: 'api/v1/NotesAndComments/Comment/UpdateComment',
      updateSVNote: 'api/v1/NotesAndComments/Note/UpdateNote',
      updateSVPredefinedComment:
        'api/v1/NotesAndComments/PredefinedComment/UpdatePredefinedComment',
      updateView: 'api/v2/MaterialManagement/MMViewConfiguration/UpdateMaterialManagementView',
      uploadCalculationLineDetail:
        'api/v2/MaterialManagement/MMViewConfiguration/postuploadcalculationlinedetail',
      uploadFlagList: 'api/v1/materialmanagement/partnumbers/getpartnumbervendorcodeflags ',
      uploadPortfolio: 'api/v1/materialmanagement/partnumbers/PostUploadContacts',
      uploadQuotation: 'api/v1/Quotations/PostUploadQuotation',
      uploadVendorList: 'api/v1/MaterialManagement/PartNumbers/PostUploadContacts',
      userDataRule: 'api/v1/UserdataRule',
      userSettings: 'UserSettings',
      ValidatePartNumberVendorCode:
        'api/v1/MaterialManagement/PartNumbers/ValidatePartNumberVendorCode/',
      VendorNotification: 'api/v1/Contacts',
      vendors: 'api/v1/materialmanagement/vendors',
      vendorsContacts: 'api/v1/identityhub/getidentitybykey',
      vendorSectionName: 'api/v1/MaterialManagement/PartNumbers/GetVendorCodeSectionNames',
      vendorSectionNameByContact:
        '/api/v1/MaterialManagement/PartNumbers/GetVendorCodeSectionNamesByContact',
      views: 'api/v2/MaterialManagement/MMViewConfiguration/GetMaterialManagementViews',
      virtualPartNumbers: 'api/v1/MaterialManagement/VirtualPartNumbers',
      waterfall: 'api/v1/materialmanagement/waterfall/generate',
    },
    plants: [],
    process: {
      getConnectorParameters: 'api/v1/Workflow/Catalogue/GetConnectorParameters',
      getProcessParameters: 'api/v1/WorkFlow/Catalogue/GetProcessParameters',
    },
  },
  plantHealthCheck: {
    checkHealth: 'api/-/health',
  },
  tokenConfig: {
    tokenExpireOffsetInSeconds: 30, // in Seconds
  },
};
